// Copyright (c) 2017 Deere & Company

import NotificationsList from '../state/notifications';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const readNotifications = (state, action) =>
    NotificationsList.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().notifications, action) => {

    const actionTypes = {
        [actions.GET_NOTIFICATIONS]: readNotifications
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/notifications.js